import { z } from "zod";

const Attributes = z.record(z.string(), z.string());

export const GameSpan = z.object({
  traceId: z.string(),
  spanId: z.string(),
  parentSpanId: z.string().nullable(),
  name: z.string(),
  kind: z.enum(["server", "client", "internal", "producer", "consumer"]),
  service: z.string(),
  /** What is true of the whole process that wrote it, such as its build and the agent it runs. */
  resource: Attributes,
  /** The library that recorded it. */
  scope: z.string(),
  startedAt: z.string(),
  durationMs: z.number(),
  status: z.enum(["unset", "ok", "error"]),
  statusMessage: z.string().nullable(),
  attributes: Attributes,
  /** Moments within it, such as the exception that ended it, oldest first. */
  events: z.array(z.object({ name: z.string(), at: z.string(), attributes: Attributes })),
  /** Spans in other traces it follows from, such as the request that launched its process. */
  links: z.array(z.object({ traceId: z.string(), spanId: z.string(), attributes: Attributes })),
});
export type GameSpan = z.infer<typeof GameSpan>;

export const GameSpansQuery = z.object({
  before: z
    .string()
    .regex(/^\d+-[0-9a-f]{16}$/)
    .optional()
    .meta({ description: "The `older` cursor of the previous page; the newest page when absent." }),
});

export const GameSpansResponse = z.object({
  /** Newest first. */
  spans: z.array(GameSpan),
  /** Pass as `before` for the next older page; null on the oldest page. */
  older: z.string().nullable(),
});
export type GameSpansResponse = z.infer<typeof GameSpansResponse>;
